'use client';

import styles from './skip-to-main-content.module.scss';

const handleJumpToContent = () => {
	// Find the first element after the header and set focus to it.
	// We have two headers SSRed into the DOM as siblings (mobile + desktop)
	// and need to make sure we skip past both of them.
	const mainContent = document.querySelector('header ~ header ~ *');
	mainContent.setAttribute('tabindex', '-1');
	mainContent.focus();
	mainContent.scrollIntoView();
};

const SkipToMainContent = () => {
	return (
		<button
			className={`${styles.skipToMainContent} button primary`}
			onClick={handleJumpToContent}
			id="skip-to-main-content-button"
		>
			Skip to main content
		</button>
	);
};

export default SkipToMainContent;
